/**
 * For each element in an array of objects, append a `hasChildren` property that
 * is true if the `children` property is an non-empty array
 * @param {array} arr Input array
 * @returns Enriched array
 */
const addHasChildren = (arr = []) => arr.map(x => {
  var _a;
  return ((_a = x.children) === null || _a === void 0 ? void 0 : _a.length) ? Object.assign(Object.assign({}, x), {
    hasChildren: true,
    children: addHasChildren(x.children)
  }) : Object.assign(Object.assign({}, x), {
    hasChildren: false
  });
});

export { addHasChildren };
//# sourceMappingURL=addHasChildren.js.map
